import { useCachedQuery } from '../../hooks/useCachedQuery';

// Dados gerais do paciente, com cache de leitura offline (via useCachedQuery).
export function usePatient(patientId) {
  const url = patientId ? `/patients/${patientId}` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    patient: data ?? null,
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
